import React from "react";
import { makeStyles } from "@material-ui/core";
import Modal from "@material-ui/core/Modal";
import Backdrop from "@material-ui/core/Backdrop";
import Fade from "@material-ui/core/Fade";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import HelpIcon from "@material-ui/icons/HelpOutline";
import { Context as AuthContext } from '../../context/auth.context';

const useStyles = makeStyles((theme) => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    padding: theme.spacing(2, 4, 3),
    outline: "none",
    borderRadius: 8,
    width: 500,
    maxWidth: 500,
  },
  table: {
    minWidth: 650,
  },
}));

const ControlMessage = (props) => {
  const auth = React.useContext(AuthContext);
  const classes = useStyles();
  const defaultMessage = "This invoice cannot be paid until all prior year invoices are paid first";
  const defaultMessageDisplayOnly = "This invoice is locked. Please contact " + auth.state.merchant.merchantName + " directly to pay.";
  const messageDisplayResults = (props.controlMessage && props.controlMessage != '') ? props.controlMessage : ((props.controlOrder == -1) ? defaultMessageDisplayOnly : defaultMessage);

  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      className={classes.modal}
      open={props.modalOpen}
      onClose={() => props.setModalOpen(false)}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
    >
      <Fade in={props.modalOpen}>
        <div className={classes.paper}> 
          <p>
            {messageDisplayResults}
          </p>

          <div style={styles.bottomBar}>
            <Button
              variant="contained"
              onClick={() => props.setModalOpen(false)}
            >
              Close
            </Button>
          </div>
        </div>
      </Fade>
    </Modal>
  );
};

const styles = {
  bottomBar: {
    display: "flex",
    flexDirection: "row",
    width: "100%",
    justifyContent: "flex-end",
    borderTop: "1px solid #ddd",
    paddingTop: 25,
    marginTop: 25,
  },
  topBar: {
    display: "flex",
    flexDirection: "row",
    width: "100%",
    alignItems: "center",
    justifyContent: "space-between",
    paddingTop: 15,
    paddingBottom: 15,
    borderBottom: "1px solid #ddd",
    marginBottom: 25,
  },
};

export default ControlMessage;
